import {
  type CommonCustomErrorResponse,
  type ProblemDetails,
  type WebV1SurveysCheckDisplayListData,
  Surveys
} from '@credit-web/services/product-journey-girar'
import { type AllServicesQueryParams, type TransformTypesToCamelCase } from '@credit-web/services/types'

// eslint-disable-next-line no-restricted-imports
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

export type UseSurveysCheckDisplayListResponse = TransformTypesToCamelCase<WebV1SurveysCheckDisplayListData>

/**
 * No description
 *
 * @tags hook
 * @name useSurveysCheckDisplayList
 * @summary Get Check Display by Key
 * @request GET:/api/web/v1/surveys/{key}/check-display
 * @secure
 * @response `200` `WebV1SurveysCheckDisplayListData` OK
 * @response `400` `CommonCustomErrorResponse` Bad Request
 * @response `403` `ProblemDetails` Forbidden
 */
export const useSurveysCheckDisplayList = (
  params: AllServicesQueryParams & { key?: string | null | undefined },
  queryOptions?: UseQueryRequestOptions<UseSurveysCheckDisplayListResponse, CommonCustomErrorResponse | ProblemDetails>
) => {
  const key = params.key || ''
  const { data: response, ...restQuery } = useQueryRequest<
    UseSurveysCheckDisplayListResponse,
    CommonCustomErrorResponse | ProblemDetails
  >(
    ['webV1SurveysCheckDisplayList', key],
    () => Surveys.webV1SurveysCheckDisplayList(key, { query: { Document: params?.Document } }),
    {
      retry: 3,
      retryDelay: 100,
      enabled: Boolean(key),
      ...queryOptions
    }
  )
  return { data: response?.data, content: response?.data?.content, ...restQuery }
}
